/** Clones an SVGElement while preserving type information. */
export function cloneSvg(svg: SVGElement): SVGElement {
  return svg.cloneNode(true) as SVGElement;
}
